// AutoLogout.js
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { callLogoutAPI } from '../Services/logoutService';

const AUTO_LOGOUT_TIME = 15 * 60 * 1000; // 15 minutes
//const AUTO_LOGOUT_TIME = 10 * 1000; // 30 seconds
//const AUTO_LOGOUT_TIME = 60 * 1000; // 1 minute

const AutoLogout = ({ children }) => {
  const timerRef = useRef(null);
  const navigate = useNavigate();

  const logout = async () => {

  const result = await callLogoutAPI('manual');
 
   if (result.status === 'success') {
      navigate('/');
     sessionStorage.clear();
   }
   else{
   }
  };

  const resetTimer = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(logout, AUTO_LOGOUT_TIME);
  };

  useEffect(() => {
    const events = ['mousemove', 'keydown', 'click', 'scroll'];

    events.forEach(event =>
      window.addEventListener(event, resetTimer)
    );

    resetTimer();

    return () => {
      events.forEach(event =>
        window.removeEventListener(event, resetTimer)
      );
      clearTimeout(timerRef.current);
    };
  }, []);

  return <>{children}</>;
};

export default AutoLogout;
